import { render, staticRenderFns } from "./OwnerOccupancy.vue?vue&type=template&id=6b6ef44c&scoped=true&"
import script from "./OwnerOccupancy.vue?vue&type=script&lang=js&"
export * from "./OwnerOccupancy.vue?vue&type=script&lang=js&"
import style0 from "./OwnerOccupancy.vue?vue&type=style&index=0&id=6b6ef44c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ef44c",
  null
  
)

export default component.exports